/**
 * Brandner Registration Enhancement
 *
 * - Tab-Logik (Anmelden / Registrieren) im Popup
 * - Single-Step Registrierung (Email + PW + PW-Confirm + Newsletter + Datenschutz)
 * - DOI-Aktivierungs-Bildschirm im Popup
 * - Client-seitige Passwort-Bestaetigung
 */
(function($) {
    'use strict';

    // =====================================================================
    // Popup-Initialisierung: Wird bei jedem Popup-Oeffnen aufgerufen
    // =====================================================================
    function initPopupRegistration() {
        var $popup = $('#login-form-popup');
        if (!$popup.length) return;

        var $container = $popup.find('.brandner-popup-container');
        if (!$container.length) return;

        // Schon initialisiert?
        if ($container.data('brandner-init')) return;
        $container.data('brandner-init', true);

        initTabs($container);
        initPasswordValidation($container);

        // Pruefen ob Register-Tab direkt geoeffnet werden soll
        // (via porto-link-register Klick oder URL-Parameter)
        if (window._brandnerOpenRegisterTab) {
            switchTab($container, 'register');
            window._brandnerOpenRegisterTab = false;
        }
    }

    // =====================================================================
    // Tab-Switching
    // =====================================================================
    function initTabs($container) {
        var $tabs = $container.find('.brandner-popup-tab');

        // Tab-Klick
        $tabs.on('click', function(e) {
            e.preventDefault();
            var tab = $(this).data('tab');
            switchTab($container, tab);
        });

        // "Noch kein Konto? Jetzt registrieren" Link im Login-Tab
        $container.find('.brandner-switch-to-register').on('click', function(e) {
            e.preventDefault();
            switchTab($container, 'register');
        });

        // "Bereits ein Konto? Anmelden" Link im Register-Tab
        $container.find('.brandner-switch-to-login').on('click', function(e) {
            e.preventDefault();
            switchTab($container, 'login');
        });
    }

    function switchTab($container, tabName) {
        var $tabs = $container.find('.brandner-popup-tab');
        var $contents = $container.find('.brandner-tab-content');

        $tabs.removeClass('active');
        $tabs.filter('[data-tab="' + tabName + '"]').addClass('active');

        $contents.hide().removeClass('active');
        $contents.filter('[data-tab-content="' + tabName + '"]').show().addClass('active');
    }

    // =====================================================================
    // Client-seitige Validierung
    // =====================================================================
    function validateRegistrationForm($container) {
        var $email = $container.find('#reg_email');
        var $pw1 = $container.find('#reg_password');
        var $pw2 = $container.find('#reg_password2');
        var $privacy = $container.find('#brandner_privacy');
        var $status = $container.find('.status');

        // Reset
        $status.hide().text('');
        $email.removeClass('brandner-input-error');
        $pw1.removeClass('brandner-input-error');
        if ($pw2.length) $pw2.removeClass('brandner-input-error');

        // E-Mail pruefen
        var emailVal = $email.val() ? $email.val().trim() : '';
        if (!emailVal) {
            showError($status, 'Bitte geben Sie Ihre E-Mail-Adresse ein.');
            $email.addClass('brandner-input-error').focus();
            return false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
            showError($status, 'Bitte geben Sie eine g\u00fcltige E-Mail-Adresse ein.');
            $email.addClass('brandner-input-error').focus();
            return false;
        }

        // Passwort pruefen
        var pw1Val = $pw1.val() || '';
        if (!pw1Val) {
            showError($status, 'Bitte geben Sie ein Passwort ein.');
            $pw1.addClass('brandner-input-error').focus();
            return false;
        }

        // Passwort-Bestaetigung pruefen
        if ($pw2.length) {
            var pw2Val = $pw2.val() || '';
            if (!pw2Val) {
                showError($status, 'Bitte best\u00e4tigen Sie Ihr Passwort.');
                $pw2.addClass('brandner-input-error').focus();
                return false;
            }
            if (pw1Val !== pw2Val) {
                showError($status, 'Die Passw\u00f6rter stimmen nicht \u00fcberein.');
                $pw2.addClass('brandner-input-error').focus();
                return false;
            }
        }

        // Datenschutz-Checkbox pruefen
        if ($privacy.length && !$privacy.is(':checked')) {
            showError($status, 'Bitte akzeptieren Sie die Datenschutzerkl\u00e4rung.');
            $privacy.focus();
            return false;
        }

        return true;
    }

    function showError($status, message) {
        $status.text(message).addClass('brandner-status-error').show();
    }

    // =====================================================================
    // Passwort-Bestaetigung: Live-Feedback
    // =====================================================================
    function initPasswordValidation($container) {
        var $pw1 = $container.find('#reg_password');
        var $pw2 = $container.find('#reg_password2');
        var $msg = $container.find('.brandner-pw-match-msg');

        if (!$pw1.length || !$pw2.length) return;

        function checkPasswordMatch() {
            var pw1 = $pw1.val();
            var pw2 = $pw2.val();

            if (!pw2) {
                $msg.hide();
                $pw2.removeClass('brandner-pw-match brandner-pw-mismatch');
                return;
            }

            if (pw1 === pw2) {
                $msg.text(brandnerRegistration.passwordMatch)
                    .removeClass('brandner-pw-mismatch-msg')
                    .addClass('brandner-pw-match-msg-ok')
                    .show();
                $pw2.removeClass('brandner-pw-mismatch').addClass('brandner-pw-match');
            } else {
                $msg.text(brandnerRegistration.passwordMismatch)
                    .removeClass('brandner-pw-match-msg-ok')
                    .addClass('brandner-pw-mismatch-msg')
                    .show();
                $pw2.removeClass('brandner-pw-match').addClass('brandner-pw-mismatch');
            }
        }

        $pw2.on('input', checkPasswordMatch);
        $pw1.on('input', function() {
            if ($pw2.val()) {
                checkPasswordMatch();
            }
        });
    }

    // =====================================================================
    // DOI-Aktivierungs-Bildschirm im Popup
    // =====================================================================
    function showActivationScreen($popup, email) {
        var html = '<div class="brandner-activation-screen brandner-popup-activation">' +
            '<div class="brandner-activation-icon">' +
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80" height="80" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                    '<rect x="4" y="14" width="56" height="36" rx="3" ry="3"/>' +
                    '<polyline points="4,14 32,36 60,14"/>' +
                '</svg>' +
            '</div>' +
            '<h2 class="brandner-activation-title">Fast geschafft!</h2>' +
            '<p class="brandner-activation-subtitle">Bitte bestätigen Sie Ihre E-Mail-Adresse</p>' +
            '<div class="brandner-activation-message">' +
                '<p>Wir haben eine E-Mail an <strong>' + escapeHtml(email) + '</strong> gesendet.</p>' +
                '<p>Klicken Sie auf den Aktivierungslink in der E-Mail, um Ihr Konto zu aktivieren.</p>' +
            '</div>' +
            '<div class="brandner-activation-resent-notice" style="display:none;"></div>' +
            '<div class="brandner-activation-help">' +
                '<p class="brandner-activation-help-title">Keine E-Mail erhalten?</p>' +
                '<ul>' +
                    '<li>Prüfen Sie Ihren Spam-Ordner</li>' +
                    '<li>Stellen Sie sicher, dass die E-Mail-Adresse korrekt ist</li>' +
                '</ul>' +
                '<button type="button" class="brandner-activation-resend-btn brandner-popup-resend-btn">Aktivierungsmail erneut senden</button>' +
            '</div>' +
            '<a href="#" class="brandner-activation-close-link">Popup schließen</a>' +
        '</div>';

        // Popup-Inhalt ersetzen (Klasse fuer konsistente Groesse)
        $popup.find('.brandner-popup-container')
              .addClass('brandner-popup-activation-mode')
              .html(html);

        // "Erneut senden" Button Handler
        $popup.find('.brandner-popup-resend-btn').on('click', function() {
            var $btn = $(this);
            $btn.prop('disabled', true).text('Wird gesendet...');

            $.ajax({
                type: 'POST',
                url: brandnerRegistration.ajaxUrl,
                data: {
                    action: 'brandner_resend_activation',
                    email: email
                },
                success: function(response) {
                    var $notice = $popup.find('.brandner-activation-resent-notice');
                    if (response.success) {
                        $notice.text(response.data.message)
                               .removeClass('brandner-resent-error')
                               .addClass('brandner-resent-success')
                               .show();
                    } else {
                        $notice.text(response.data.message)
                               .removeClass('brandner-resent-success')
                               .addClass('brandner-resent-error')
                               .show();
                    }
                    $btn.prop('disabled', false).text('Aktivierungsmail erneut senden');
                },
                error: function() {
                    $btn.prop('disabled', false).text('Aktivierungsmail erneut senden');
                }
            });
        });

        // "Popup schliessen" Link
        $popup.find('.brandner-activation-close-link').on('click', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    }

    function escapeHtml(text) {
        var map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }

    // =====================================================================
    // AJAX Registration Handler (Override Porto's default)
    // =====================================================================
    function initAjaxRegistration() {
        // Prevent form submit (Enter key) from being handled by Porto
        $(document).on('submit', '#login-form-popup .brandner-register-form', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).find('.brandner-submit-register').trigger('click');
        });

        $(document).on('click', '#login-form-popup .brandner-register-form .brandner-submit-register', function(e) {
            e.preventDefault();
            e.stopPropagation();

            // Guard: brandnerRegistration muss definiert sein
            if (typeof brandnerRegistration === 'undefined' || !brandnerRegistration.ajaxUrl) {
                console.error('brandnerRegistration nicht verfuegbar');
                return;
            }

            var $btn = $(this);
            var $form = $btn.closest('form');
            var $popup = $btn.closest('#login-form-popup');
            var $container = $popup.find('.brandner-popup-container');

            // Client-seitige Validierung
            if (!validateRegistrationForm($container)) {
                return;
            }

            var $status = $form.find('.status');

            $status.show().text('Bitte warten...').removeClass('brandner-status-error').addClass('loading');
            $btn.prop('disabled', true);

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: brandnerRegistration.ajaxUrl,
                data: $form.serialize() + '&action=porto_account_login_popup_register',
                success: function(data) {
                    $btn.prop('disabled', false);

                    if (data.needs_activation) {
                        // DOI: Aktivierungs-Bildschirm anzeigen
                        showActivationScreen($popup, data.email);
                    } else if (data.loggedin === true) {
                        $status.html(data.message).removeClass('loading');
                        window.location.reload();
                    } else {
                        // Fehler
                        $status.html(data.message).removeClass('loading').addClass('brandner-status-error');
                    }
                },
                error: function(xhr, textStatus, errorThrown) {
                    $btn.prop('disabled', false);
                    console.error('Registrierung AJAX-Fehler:', textStatus, errorThrown);
                    $status.text('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.').removeClass('loading').addClass('brandner-status-error');
                }
            });
        });
    }

    // =====================================================================
    // Registrieren-Link: Flag setzen fuer Tab-Oeffnung
    // =====================================================================
    function initRegisterLinkTrigger() {
        // Porto's magnific popup wird fuer .porto-link-register geoeffnet
        // Wir setzen ein Flag, damit beim Popup-Oeffnen der Register-Tab aktiv wird
        $(document).on('click', '.porto-link-register', function() {
            window._brandnerOpenRegisterTab = true;
        });

        // Bei .porto-link-login sicherstellen, dass Login-Tab oeffnet
        $(document).on('click', '.porto-link-login, a.my-account', function() {
            window._brandnerOpenRegisterTab = false;
        });
    }

    // =====================================================================
    // Init
    // =====================================================================
    $(document).ready(function() {
        initRegisterLinkTrigger();
        initAjaxRegistration();
    });

    // Porto feuert dieses Event wenn das Login-Popup geoeffnet wird
    $(window).on('porto_login_popup_opened', function() {
        // Kurze Verzoegerung damit DOM bereit ist
        setTimeout(initPopupRegistration, 50);
    });

})(jQuery);
